export function pushDataLayer(event, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}

export function getPageType() {
    const path = window.location.pathname;
    if (path.includes('/veicolo/')) return 'vehicle';
    if (path.includes('/veicoli')) return 'listing';
    if (path.includes('/contatti')) return 'contacts';
    if (path.includes('/service')) return 'service';
    if (path.includes('/carrozzeria')) return 'carbody';
    if (path.includes('/noleggio-lungo-termine')) return 'long-term';
    if (path.includes('/noleggio-veicoli-commerciali')) return 'commercial';
    if (path.includes('/noleggio-california')) return 'california';
    if (path.includes('/porsche')) return 'porsche';
    if (path.includes('/chi-siamo')) return 'about';
    if (path.includes('/marchi')) return 'brands';
    if (path.includes('/faq')) return 'faq';
    if (path.includes('/preferiti')) return 'bookmark';
    if (path === '/' || path === '') return 'home';
    return 'other';
}

export const toPrice = (n) => {
    return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(n);
}

export const toFormat = (n) => {
    return new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(n);
}

// funzione per la verifica dell'esistenza del cookie 
export function getCookieForBookmark(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');

    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length) === 'true';
        }
    }
    return null;
}

// Funzione per impostare il cookie con un array di codici ID
export function setCookieForBookmark(cookieName, booleanValue, expirationDays) {
    // Converti il valore booleano in una stringa ('true' o 'false')
    var stringValue = booleanValue ? 'true' : 'false';

    var d = new Date();
    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();

    // Imposta il cookie con il valore booleano
    document.cookie = cookieName + "=" + stringValue + "; " + expires + "; path=/";
}

export function translate(key) {

    if (global.text[key]) {
        return global.text[key].Testo
    }

    return "---------"
}


export function translateValue(key) {

    if (global.text[key]) {
        return global.text[key].Link
    }

    return "";
}

export const endPrice = (data) => {
    if (data.PrezzoScontato) {
        return data.PrezzoScontato
    }
    return data.PrezzoFinale
}